var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: "Cadastrar Protesto" },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "validation-observer",
            {
              ref: "validation",
              staticClass: "analise",
              attrs: { tag: "div" }
            },
            [
              _c("validation-provider", {
                attrs: { rules: "required", name: "motivo" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var errors = ref.errors
                      return [
                        _c("app-label", {
                          attrs: { label: "Motivo:", required: true }
                        }),
                        _c("el-input", {
                          class: { erro: errors.length },
                          model: {
                            value: _vm.motivo,
                            callback: function($$v) {
                              _vm.motivo = $$v
                            },
                            expression: "motivo"
                          }
                        }),
                        _c("span", { staticClass: "help erro" }, [
                          _vm._v(_vm._s(errors[0]))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _c(
                "div",
                { staticClass: "mt-30px" },
                [
                  _c("app-label", {
                    attrs: { label: "Justificativa:", required: true }
                  }),
                  _c("validation-provider", {
                    attrs: { rules: "required", name: "justificativa" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("app-editor-texto", {
                              ref: "editorTexto",
                              staticClass: "input",
                              class: { erro: errors.length },
                              on: { onTextChange: _vm.onTextChange },
                              model: {
                                value: _vm.justificativa,
                                callback: function($$v) {
                                  _vm.justificativa = $$v
                                },
                                expression: "justificativa"
                              }
                            }),
                            _c("span", { staticClass: "help erro" }, [
                              _vm._v(_vm._s(errors[0]))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("app-anexo", {
                    attrs: {
                      id: "upload-anexo",
                      files: _vm.anexos,
                      tipoExibir: "ANEXO_ANALISE"
                    },
                    on: {
                      uploadFile: _vm.uploadFile,
                      removeFile: _vm.removeFile,
                      downloadDocumentoCadastro: _vm.downloadDocumentoCadastro
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "space-between" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.$emit("closeModal")
                    }
                  }
                },
                [_c("b", [_vm._v("Cancelar")])]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "success", size: "small" },
                  on: { click: _vm.save }
                },
                [
                  _c("i", { staticClass: "fa fa-share-square" }, [_vm._v(" ")]),
                  _c("b", [_vm._v("  Cadastrar")])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3da3a1fd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3da3a1fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/modal/AppModalCadastrarProtesto.vue
// module id = null
// module chunks = 